import { Navigate } from 'react-router-dom';
import { UserAuth } from '../pages/auth/Auth';

const RedirectIfLoggedIn = ({ children, redirectTo }) => {
  const { isLoggedIn } = UserAuth();

  if (isLoggedIn) {
    return <Navigate to={redirectTo} replace />;
  }

  return children;
};

export default RedirectIfLoggedIn;